import { render, staticRenderFns } from "./ClearCompletedTransfers.vue?vue&type=template&id=fbab6b78"
import script from "./ClearCompletedTransfers.vue?vue&type=script&lang=js"
export * from "./ClearCompletedTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports